import { ReactElement } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./CustomRadio.module.scss";

interface IProps {
  items: {
    label: string | ReactElement;
    index: number;
  }[];
  selectedIndex: number;
  onChange: (index: number) => void;
  className?: string;
}

const CustomRadio = (props: IProps) => {
  return (
    <Row>
      <Col>
        <div
          style={{
            backgroundColor: "#E5EFFF",
            borderRadius: "30px",
            padding: "15px",
          }}
        >
          <div
            className={[styles.radioButton, props.className].join(" ")}
            style={{ backgroundColor: "#FFFFFF" }}
          >
            {props.items.map((item) => (
              <div
                key={item.index}
                className={[
                  "text-center",
                  styles.item,
                  props.selectedIndex === item.index && styles.active,
                ].join(" ")}
                onClick={() => props.onChange(item.index)}
              >
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default CustomRadio;
